import { TypedMoney } from "@commercetools/platform-sdk";

import { transformCents } from "@/features/product/hooks/use-price";

const getSalePriceWithVat = (salePrice: number, vatPrice: number, total: TypedMoney) => {
  if (!total) return 0;
  return Number(
    transformCents({ ...total, centAmount: salePrice + vatPrice }).toFixed(
      total?.fractionDigits || 2,
    ),
  );
};

export const getPrices = (total: TypedMoney, markup: number, vat: number) => {
  const { centAmount: totalPrice = 0 } = total || {};
  const markupPrice = markup && markup > 0 ? (totalPrice * markup) / 100 : 0;
  const vatPrice = vat && vat > 0 ? (totalPrice * vat) / 100 : 0;
  const salePrice = totalPrice ? totalPrice + markupPrice : 0;
  const salePriceWithVat = getSalePriceWithVat(salePrice, vatPrice, total);

  return {
    markupPrice,
    vatPrice,
    salePrice,
    salePriceWithVat,
  };
};

export const getMarkupFromSalePriceWithVat = (
  total: TypedMoney,
  priceWithVat: number,
  vat: number,
) => {
  if (!priceWithVat && priceWithVat < 0) return 0;
  const vatPrice = vat && vat > 0 ? (total.centAmount * vat) / 100 : 0;
  const salePrice = priceWithVat * Math.pow(10, total?.fractionDigits || 2) - vatPrice;
  const markupPrice = salePrice - total.centAmount;
  return Number(((markupPrice / total.centAmount) * 100).toFixed(total.fractionDigits || 2));
};
